;(function() {
  'use strict'

  angular.module('core.sentimentChart', [])
})()
